import { ref } from 'vue'
import { router } from '@inertiajs/vue3'

export const useSearch = (url, only) => {

  const search = ref(route().params.filter && route().params.filter.q ? route().params.filter.q : '')
  const baseRoute = ref(url)
  const onlyProps = ref(only || [])

  const onSearch = () => {
    if (!search.value || search.value.length === 0) {
      return
    }

    router.get(baseRoute.value, {
      filter: {
        q: search.value,
      }
    }, {
      only: onlyProps.value,
    })
  }

  const clearSearch = () => {
    let shouldRefreshUrl = route().params.filter && route().params.filter.q

    search.value = ''

    if (shouldRefreshUrl) {
      router.get(baseRoute.value, {}, {
        only: onlyProps.value,
      })
    }
  }

  return {
    search,
    onSearch,
    clearSearch,
    onlyProps,
  }
}
